import React from "react";
import PropTypes from "prop-types";
import randomId from "./random_id";

const ButtonWithModal = (props) => {
  const {
    buttonLabel,
    children,
    modalTitle
  } = props;
  const id = randomId("id");
  const idLabel = randomId("id-label");

  return (
    <div>
      <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${id}`}>
        {buttonLabel}
      </button>

      <div className="modal fade" id={id} tabIndex="-1" role="dialog" aria-labelledby={idLabel}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title" id={idLabel}>{modalTitle || buttonLabel}</h4>
            </div>
            <div className="modal-body">
              {children}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ButtonWithModal.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  modalTitle: PropTypes.string.isRequired,
};

export default ButtonWithModal;
